import React from 'react'
import { ShowWhatYouKnow } from 'cvs-core'
import voAudio from '../../assets/vo/Challenge-Post-test-01.mp3'
import img1 from '../../assets/images/U1-T1-13a.svg'

const vo = {
  src: voAudio,
}
const topic = 'the effects of vaping or using e-cigarettes'

export default {
  title: 'Show What You Learned',
  path: '/challenge/show-what-you-learned',
  content: <ShowWhatYouKnow topic={topic} vo={vo} image={img1} />,
}



// WEBPACK FOOTER //
// ./src/data/Challenge/ShowWhatYouLearned.js